import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { ApplicationListParams } from '../model/application-list-params';
import * as applicationList from '../actions/application-list.actions';
import * as application from '../actions/application.actions';
import { Globals } from '../../../app.globals';
import { ModuleRoutingConstants } from '../../../core/helpers/module-routing.constants';
import { Params } from '@angular/router/src/shared';
import { pageInfoFromQueryParams } from '../../shared/helper/router-params';
import { ofRoute, ofRouteExit } from '../../../core/router/route-operator';
import { map, combineLatest, filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { ApplicationsState } from '../applications.state';
import { selectUrlParams } from '../../url-params/url-params.selector';
import * as routerActions from '../../../core/actions/router.actions';
import { selectConfig } from '../../config/config.selector';

@Injectable()
export class ApplicationEffects {

    @Effect() routeChangeIn$ = this.actions$.pipe(
        ofRoute(ModuleRoutingConstants.APPLICATIONS),
        combineLatest(
            this.store.select(selectUrlParams),
            this.store.select(selectConfig)
        ),
        filter(([action, urlParams, config]) => !!urlParams.access_token && !!action && !!config && !!config.webApiKey),
        // Počká, dokud není access_token a webApiKey dostupný
        map(([action]) => {
            return new applicationList.ChangeParamsAction(this.parseOrDefaults((action as routerActions.RouteChange).payload.queryParams));
        })
    );

    /**
     * Side effect to clean module state when navigation out of module.
     */
    @Effect() routeChangeOut$ = this.actions$.pipe(
        ofRouteExit(ModuleRoutingConstants.APPLICATIONS),
        map(() => new application.ClearStoreAction())
    );

    /**
     * Method prepares ApplicationListParams for data retrieval.
     * @param {Params} queryParams
     * @return {ApplicationListParams}
     */
    private parseOrDefaults = (queryParams: Params): ApplicationListParams => {
        const pageInfo = pageInfoFromQueryParams(queryParams, Globals.itemsPerPage.common);
        return new ApplicationListParams(pageInfo.page, pageInfo.itemsPerPage);
    }

    constructor(
        private actions$: Actions,
        private store: Store<ApplicationsState>
    ) {}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/effects/application.effects.ts